<template>
  <div class="occ-filter mb-3">
    <div
      class="occ-filter__box"
      :class="{ 'occ-filter__box--active': hasTerm }"
    >
      <feather-icon
        icon="SearchIcon"
        size="16"
        class="occ-filter__icon"
      />
      <input
        ref="input"
        :value="value"
        type="text"
        class="occ-filter__input"
        placeholder="Filtrar por protocolo, nome, endereço, tipo..."
        aria-label="Filtrar ocorrências"
        autocomplete="off"
        @input="$emit('input', $event.target.value)"
        @keydown.esc.prevent="clear(true)"
        @keydown.enter.prevent="$emit('submit')"
      >
      <b-spinner
        v-if="loading"
        small
        class="occ-filter__spinner"
      />
      <button
        v-if="value"
        type="button"
        class="occ-filter__clear"
        title="Limpar filtro"
        aria-label="Limpar filtro"
        @click="clear(false)"
      >
        <feather-icon
          icon="XIcon"
          size="16"
        />
      </button>
    </div>
    <small
      v-if="applied && !loading"
      class="occ-filter__count"
    >{{ countText }}</small>
  </div>
</template>

<script>
import { BSpinner } from 'bootstrap-vue'
import { FILTER_MIN_LENGTH } from '@/mixins/OccurrenceFilterMixin'

export default {
  name: 'OccurrenceFilterBar',

  components: { BSpinner },

  props: {
    value: { type: String, default: '' },
    applied: { type: String, default: '' },
    loading: { type: Boolean, default: false },
    count: { type: Number, default: 0 },
  },

  computed: {
    hasTerm() {
      return this.value.trim().length >= FILTER_MIN_LENGTH
    },

    countText() {
      const termo = `"${this.applied}"`
      if (!this.count) return `Nenhuma ocorrência para ${termo}`
      return `${this.count} ${this.count === 1 ? 'ocorrência' : 'ocorrências'} para ${termo}`
    },
  },

  mounted() {
    window.addEventListener('keydown', this.onGlobalKeydown)
  },

  beforeDestroy() {
    window.removeEventListener('keydown', this.onGlobalKeydown)
  },

  methods: {
    onGlobalKeydown(e) {
      if (e.key !== '/' || e.ctrlKey || e.metaKey || e.altKey) return
      const el = document.activeElement
      const tag = el ? el.tagName : ''
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || (el && el.isContentEditable)) return
      e.preventDefault()
      this.$refs.input.focus()
    },

    clear(blur) {
      this.$emit('input', '')
      if (blur) {
        this.$refs.input.blur()
      } else {
        this.$refs.input.focus()
      }
    },
  },
}
</script>

<style scoped>
.occ-filter__box {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 42px;
  padding: 0 12px;
  background: #fff;
  border: 1px solid #d8d6de;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  transition: border-color 0.15s, box-shadow 0.15s;
}

.occ-filter__box:focus-within,
.occ-filter__box--active {
  border-color: #7367f0;
  box-shadow: 0 0 0 3px rgba(115, 103, 240, 0.15);
}

.occ-filter__icon {
  flex-shrink: 0;
  color: #7367f0;
}

.occ-filter__input {
  flex: 1;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  font-size: 14px;
  color: #5e5873;
}

.occ-filter__input::placeholder {
  color: #b9b9c3;
}

.occ-filter__clear {
  display: flex;
  padding: 4px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: #6e6b7b;
  cursor: pointer;
}

.occ-filter__clear:hover {
  color: #ea5455;
  background: rgba(234, 84, 85, 0.1);
}

.occ-filter__count {
  display: block;
  margin-top: 6px;
  font-size: 12px;
  color: #6e6b7b;
}

.dark-layout .occ-filter__box {
  background: #283046;
  border-color: #404656;
}

.dark-layout .occ-filter__box:focus-within,
.dark-layout .occ-filter__box--active {
  border-color: #7367f0;
}

.dark-layout .occ-filter__input {
  color: #d0d2d6;
}

.dark-layout .occ-filter__input::placeholder {
  color: #676d7d;
}

.dark-layout .occ-filter__count {
  color: #b4b7bd;
}

.occ-filter__spinner {
  flex-shrink: 0;
  color: #7367f0;
}
</style>
